<div
  class="assignable-expanded-composite-container"
    [ngClass]="{
        ipas:
            asset?.assetTypeId === assetTypeIds.BUNDLE &&
            asset?.assetActivityTypeId === assetActivityTypeIds.IPA
    }"
  >
  <!-- Modules and Assessments Card -->
  @if (
    asset?.assetTypeId === assetTypeIds.BUNDLE &&
    asset?.assetActivityTypeId === assetActivityTypeIds.IPA
    ) {
    <div
      class="guides-directions"
      >
      <mat-card appearance="outlined">
        <mat-card-content class="directions">
          <img
            class="module-img"
            [src]="getImagePath(asset)"
            alt="{{ asset?.displayName }} image"
            />
          <p [innerHTML]="asset?.description"></p>
        </mat-card-content>
      </mat-card>
      <!-- IG and SG external links -->
      @if (
        asset?.assetTypeId === assetTypeIds.BUNDLE &&
        asset?.assetActivityTypeId === assetActivityTypeIds.IPA
        ) {
        <div
          class="guide-buttons"
          >
          <a
            mat-button
            color="primary"
            href="{{ getIPAIntegrationGuideUrl(asset) }}"
            target="_blank"
            >
            Integration Guide
          </a>
          @for (levelId of asset.levelIds; track levelId) {
            <a
              mat-button
              color="primary"
              href="{{ getIPAScoringGuideUrl(levelId) }}"
              target="_blank"
              >{{ getLevelDisplayName(asset.subjectId, levelId) }} Scoring
              Guide</a
              >
            }
          </div>
        }
      </div>
    }

    <assignable-task-categories
      [taskCategories]="asset?.tasks"
      [selectedAssets]="selectedAssets"
      [creatingLesson]="creatingLesson"
      (toggleCategoryEvent)="toggleSelectedCategoryEvent($event)"
    ></assignable-task-categories>
  </div>
